import { Action, Topbox, topboxHandler } from "../Chart/NewDocForm";

export type CustomChartFormState = {
  topbox?: Topbox;
  isDirty: boolean;
  filter: any;
  levels: number;
};

export const getInitialState = () => {
  return {
    levels: -1,
    topbox: undefined,
    isDirty: false,
    filter: undefined
  };
};

export const customChartFormReducer = (state: CustomChartFormState, action: Action) => {
  const dirtyState = { ...state, isDirty: true };

  switch (action.type) {
    case "SET_LEVELS":
      return { ...dirtyState, levels: action.payload };
    case "SET_TOPBOX":
      return topboxHandler<CustomChartFormState>(action, dirtyState);
    case "SET_FILTER":
      return { ...dirtyState, filter: action.payload };
    case "RESET":
      return getInitialState();
    default:
      return state;
  }
};
